export function highchartsSetup() {

    $(".graphics-control-item").on('click', function (event) {
        let _this = $(this);
        if (!_this.hasClass("active")) {
            let ind = _this.index();
            _this.addClass('active').siblings().removeClass('active');
            $('.graphics-item').eq(ind).addClass('active').siblings().removeClass('active');
        }
    });

    $('.graphics-item').each(function (index, el) {
        let elementPath = this.dataset.path;
        let elementTitle = this.dataset.title;
        let elementHolder = this.querySelector(".graphics-item-container");

        if ($(this).hasClass("fvmp-cart")) {
            const date = [],
                gradeBid = [],
                yieldBid = [],
                volume = [];
            $.get(elementPath, function (data) {
                let lines = data.split('\n'); // get line
                lines = lines.slice(1, -1);

                lines.forEach(element => {
                    const row = element.split(','),
                        year = (new Date(row[0])).getTime(),
                        gt = +row[1],
                        nt = +row[2],
                        st = +row[3];

                    date.push(year, gt);
                    gradeBid.push([year, gt]);
                    yieldBid.push([year, nt]);
                    volume.push([year, st]);
                });
                let groupingUnits = [[
                    'week',             // unit name
                    [1]               // allowed multiples
                ], [
                    'month',
                    [1, 2, 3, 4, 6]
                ]];
                Highcharts.setOptions({
                    lang: {
                        numericSymbols: ["k", "M", "T", "P", "E"]
                    }
                });
                Highcharts.stockChart(elementHolder, {
                    rangeSelector: {
                        selected: 4
                    },
                    /*
                    title: {
                        text: elementTitle,
                        style: {
                            color: "#fff",
                            textTransform: "uppercase",
                            fontSize: "30px",
                            fontFamily: "Calibre, sans-serif"
                        }
                    },*/
                    colors: ['#FF9100', '#00A0FF', '#D8D8D8', '#8bbc21', '#910000', '#1aadce',
                        '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
                    chart: {
                        type: 'line',
                        backgroundColor: "transparent",
                        spacingBottom: 10,
                        spacingTop: 0,
                        spacingLeft: 0,
                        spacingRight: 10,
                        borderWidth: 0,
                        borderRadius: 0
                    },
                    navigator: {
                        // enabled: false
                    },
                    exporting: {
                        // enabled: false
                    },
                    tooltip: {
                        pointFormat: "{series.name}: {point.y:.2f}",/*
                        shape: 'square',
                        headerShape: 'callout',
                        borderWidth: 0,
                        shadow: false,*/
                    },
                    yAxis: [{
                        min: 0.001,
                        startOnTick: false,
                        labels: {
                            align: 'right',
                            x: -11,
                            formatter: function() {
                                const value = this.value;
                                const array = value.toString().match(/\.(\d+)/);
                                if((array || '').length == 2){
                                    if(array[1].length == 1)
                                        return value + '0';
                                    else return (parseInt(value * 100)) / 100;
                                }else
                                    return value +'.00';
                            }
                        },
                        title: {
                            text: 'FVMP Bid Offer ($)',
                            x: 0
                        },
                        height: '60%',
                        lineWidth: 1,
                        opposite: false,
                        resize: {
                            enabled: true
                        },
                        zoneLines: {
                            enabled: false
                        },
                    }, {
                        labels: {
                            align: 'right',
                             //x: -75
                        },
                        height: '60%',
                        lineWidth: 1,
                        opposite: true,
                        resize: {
                            enabled: true
                        }
                    }, {
                        labels: {
                            align: 'right',
                            x: -11
                        },
                        title: {
                            text: 'TRACE™️ Volume',
                            x: 0
                        },
                        top: '60%',
                        height: '40%',
                        lineWidth: 1,
                        offset: 0,
                        opposite: false,
                        resize: {
                            enabled: true
                        }
                    }],
                    legend: {
                        enabled: true,
                        layout: 'horizontal',
                        verticalAlign: 'bottom',
                        x: 0,
                        y: 10,
                    },
                    series: [{
                        type: 'line',
                        name: 'FVMP Investment Grade Bid / Offer Index (20 day avg.)',
                        data: gradeBid,
                        yAxis: 0,
                        showInLegend:true,
                        dataGrouping: {
                            units: groupingUnits
                        }
                    }, {
                        type: 'line',
                        yAxis: 0,
                        name: 'FVMP High Yield Bid / Offer Index (20 day avg.)',
                        data: yieldBid,
                        showInLegend:true,
                        dataGrouping: {
                            units: groupingUnits
                        }
                    }, {
                        type: 'column',
                        name: 'TRACE™ Volume',
                        data: volume,
                        yAxis: 2,
                        showInLegend:true,
                        dataGrouping: {
                            units: groupingUnits
                        }
                    }],
                    responsive: {
                        rules: [{
                            condition: {
                                maxWidth: 1560
                            },
                            chartOptions: {
                                rangeSelector: {
                                    enabled: true,
                                    inputEnabled: true
                                }
                            }
                        }]
                    }
                });
            });

        } else {
            Highcharts.stockChart(elementHolder, {
                rangeSelector: {
                    selected: 4
                },
                data: {
                    csvURL: elementPath,
                },
                title: {
                    text: elementTitle,
                    style: {
                        color: "#fff",
                        textTransform: "uppercase",
                        fontSize: "30px",
                        fontFamily: "Calibre, sans-serif"
                    }
                },
                colors: ['#FF9100', '#00A0FF', '#FFFFFF', '#8bbc21', '#910000', '#1aadce',
                    '#492970', '#f28f43', '#77a1e5', '#c42525', '#a6c96a'],
                chart: {
                    type: 'line',
                    backgroundColor: "transparent",
                    spacingBottom: 10,
                    spacingTop: 0,
                    spacingLeft: 0,
                    spacingRight: 10,
                    borderWidth: 0,
                    borderRadius: 0
                },
                navigator: {
                    // enabled: false
                },
                exporting: {
                    // enabled: false
                },
                tooltip: {
                    pointFormat: "{series.name}: {point.y:.2f}"
                },
                yAxis: [{                    
                    startOnTick: false,
                    labels: {
                        align: 'right',
                        x: -11,
                        enabled: true,
                        formatter: function() {
                            const value = this.value;
                            const array = value.toString().match(/\.(\d+)/);
                            if((array || '').length == 2){
                                if(array[1].length == 1)
                                    return value + '0';
                                else return (parseInt(value * 100)) / 100;
                            }else
                                return value +'.00';
                        }
                    },
                    opposite: false,
                    title: {
                        text: 'Units in $',
                        x: 0
                    },
                    resize: {
                        enabled: true
                    },
                }],
                plotOptions: {
                    series: {
                        marker: {
                            enabled: false
                        },
                    }
                },
                legend: {
                    enabled: true,
                    layout: 'horizontal',
                    verticalAlign: 'bottom',
                    x: 0,
                    y: 10,
                },
                series: [{
                    labels: {
                        format: '{value} mb',
                        style: {
                            color: Highcharts.getOptions().colors[1]
                        }
                    },
                }]
            });
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/highcharts-setup.js